import * as React from 'react';
import Main from '../../components/main/Main';
import { useNavigate } from 'react-router-dom';
import Storage from '../../services/Storage';

export default function Dashboard() {
  const navigate = useNavigate();
  
  React.useEffect(() => {
    if (Storage.getLocalAccessToken() === null) {
      navigate('/signin', { replace: true })
    }
  }, [navigate])


  return (
      <Main></Main>
  );
}